import { Dropdown, DropdownProps } from "antd";
import React from "react";

import { Button, EllipsisMenu } from "../../../components";
import { COLORS } from "../../../constants";

type Props = {
  containerProps?: React.HTMLAttributes<HTMLDivElement>;
  dropdownProps: DropdownProps;
};

export const IconDropdown: React.FC<Props> = ({ containerProps, dropdownProps }) => {
  return (
    <div style={{ display: "inline-block" }} onClick={e => e.stopPropagation()} {...containerProps}>
      <Dropdown trigger={["click"]} {...dropdownProps}>
        <Button type="text" shape="circle">
          <EllipsisMenu fill={COLORS.black} />
        </Button>
      </Dropdown>
    </div>
  );
};
